import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { LoginSteps } from "../../../Constants/loginSteps";

export type LoginState = {
  step: string;
};

const initialState = {
  step: LoginSteps.LoginForm,
} as LoginState;

export const loginSlice = createSlice({
  name: "loginSlice",
  reducers: {
    setStep: (state, action: PayloadAction<string>) => {
      state.step = action.payload;
    },
  },
  initialState,
});

export const { setStep } = loginSlice.actions;
export default loginSlice.reducer;

export const useAuth = () => {
  const dispatch = useAppDispatch();

  const dispatchSetStep = useCallback(
    (step: string) => {
      dispatch(setStep(step));
    },
    [dispatch],
  );
  const { step } = useAppSelector((state) => state.auth);

  return {
    step,
    dispatchSetStep,
  };
};
